function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { deleteContact, deleteContacts, getContacts, newRequest, updateContact } from "../../store/actions/contacts";
import { Icon } from '@signicat/designi/components/icons';
import SharingSettings from "../common/SharingSettings";
import ListEdit from "../list/ListEdit";
import AddToList from "../list/AddToList";
import t from "../../scripts/i18n";
import "../../styling/components/common/Actions.css";
import ConfirmModal from "../common/ConfirmModal";

var Actions = function Actions(props) {
  var dispatch = useDispatch();
  var history = useHistory();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      sharingSettingsOpen = _useState2[0],
      setSharingSettingsOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      ListEditOpen = _useState4[0],
      setListEditOpen = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      actionMenuOpen = _useState6[0],
      setActionMenuOpen = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      addToListOpen = _useState8[0],
      setAddToListOpen = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showDeleteModal = _useState10[0],
      setShowDeleteModal = _useState10[1];

  var currentUserId = useSelector(function (state) {
    return state.app.userId;
  });
  var state = useSelector(function (state) {
    return state.contacts;
  });
  var lists = useSelector(function (state) {
    return state.contactLists.lists;
  }).filter(function (list) {
    return list.portalUserId === currentUserId;
  });
  var selectedContacts = state.selectedContacts;

  var handleNewRequest = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var order;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return dispatch(newRequest(selectedContacts));

            case 3:
              order = _context.sent;
              history.push("/signature/create/".concat(order.id, "/content"));
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              dispatch({
                type: 'SET_NOTIFICATION',
                notification: {
                  text: t('notification_operation_failed'),
                  type: 'error'
                }
              });
              console.log(_context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function handleNewRequest() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleDeleteContact = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setActionMenuOpen(false);
              setShowDeleteModal(false);
              _context2.prev = 2;

              if (!(!selectedContacts || selectedContacts.length <= 0)) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              _context2.next = 7;
              return dispatch(selectedContacts.length === 1 ? deleteContact(selectedContacts[0].id) : deleteContacts(selectedContacts.map(function (c) {
                return c.id;
              })));

            case 7:
              _context2.next = 9;
              return dispatch({
                type: 'DESELECT_CONTACTS'
              });

            case 9:
              dispatch(getContacts(state.tableState));
              dispatch({
                type: 'SET_NOTIFICATION',
                notification: {
                  text: 'Contact deleted successfully.',
                  type: 'success'
                }
              });
              _context2.next = 17;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](2);
              dispatch({
                type: 'SET_NOTIFICATION',
                notification: {
                  text: t('notification_operation_failed'),
                  type: 'error'
                }
              });
              console.log(_context2.t0);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 13]]);
    }));

    return function handleDeleteContact() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement("div", {
    className: "actions-container"
  }, actionMenuOpen && /*#__PURE__*/React.createElement("div", {
    className: "actions-menu"
  }, /*#__PURE__*/React.createElement("h2", null, t('action_menu')), selectedContacts.length > 0 && /*#__PURE__*/React.createElement("span", null, t('action_choose_action', {
    selectedContacts: selectedContacts.length
  })), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, selectedContacts.length <= 0 && /*#__PURE__*/React.createElement("button", {
    className: "primary",
    onClick: function onClick() {
      return history.push('/contacts/new');
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "add"
  }), t('action_menu_new_contact')), /*#__PURE__*/React.createElement("button", {
    className: "primary",
    onClick: function onClick() {
      return setListEditOpen(true);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "group"
  }), t('action_menu_make_list')), selectedContacts.length > 0 && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: "primary",
    disabled: !lists.length,
    onClick: function onClick() {
      return setAddToListOpen(true);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "group"
  }), t('action_menu_add_to_list')), /*#__PURE__*/React.createElement("button", {
    className: "primary",
    onClick: handleNewRequest
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "launch"
  }), t('action_menu_new_request')), selectedContacts.length == 1 && selectedContacts[0].portalUserId == currentUserId && /*#__PURE__*/React.createElement("button", {
    className: "primary",
    onClick: function onClick() {
      return setSharingSettingsOpen(true);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "share"
  }), t('action_menu_share')), /*#__PURE__*/React.createElement("button", {
    className: "primary",
    title: t('action_menu_delete_disabled_tooltip'),
    disabled: selectedContacts.some(function (c) {
      return c.portalUserId != currentUserId;
    }),
    onClick: function onClick() {
      return setShowDeleteModal(true);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "delete"
  }), t('action_menu_delete')))), selectedContacts.length <= 0 && /*#__PURE__*/React.createElement("span", null, t('action_menu_select_multiple_users'))), /*#__PURE__*/React.createElement("div", {
    className: "actions-button ".concat(actionMenuOpen ? 'active' : ''),
    onClick: function onClick() {
      return setActionMenuOpen(!actionMenuOpen);
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: actionMenuOpen ? '#2A0062' : 'white'
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: "24",
    width: "24"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11,21h-1l1-7H7.5c-0.88,0-0.33-0.75-0.31-0.78C8.48,10.94,10.42,7.54,13.01,3h1l-1,7h3.51c0.4,0,0.62,0.19,0.4,0.66 C12.97,17.55,11,21,11,21z"
  }), ' '))), sharingSettingsOpen && /*#__PURE__*/React.createElement(SharingSettings, {
    onClose: function onClose() {
      return setSharingSettingsOpen(false);
    },
    toUpdate: selectedContacts[0],
    updateAction: updateContact
  }), ListEditOpen && /*#__PURE__*/React.createElement(ListEdit, {
    onClose: function onClose() {
      return setListEditOpen(false);
    }
  }), addToListOpen && /*#__PURE__*/React.createElement(AddToList, {
    onClose: function onClose() {
      return setAddToListOpen(false);
    }
  }), showDeleteModal && /*#__PURE__*/React.createElement(ConfirmModal, {
    title: t('confirm_modal_delete_contact'),
    question: t('confirm_modal_delete_contact_question'),
    onCancel: function onCancel() {
      return setShowDeleteModal(false);
    },
    onConfirm: handleDeleteContact
  }));
};

export default Actions;